import { Component, Input, ViewChild } from "@angular/core";
import { CBP3461 } from "../../../../objects/documents/CBP3461";
import { ValidationPatterns } from "../../../../common/helpers/ValidationPatterns";
import { NgForm } from "@angular/forms";

@Component({
    selector: 'line-information-3461',
    templateUrl: "line-information-3461.component.html",
    moduleId: module.id.toString()
})
export class LineInformationComponent3461 {
    @Input()
    public document: CBP3461;

    public numberPatternHelper = ValidationPatterns;

    @ViewChild("lineInformationForm")
    public lineInformationForm: NgForm;


    public isFormValid(): boolean {
        return this.lineInformationForm.valid;
    }

    public submitFormAndValidity(): boolean {
        this.lineInformationForm.onSubmit(null);

        return this.isFormValid();
    }
}


// WEBPACK FOOTER //
// ./app/components/export-documents/cbp-3461/document-blocks/line-information.component-3461.ts